const vision = {
    title: "Visión",
    description: "Ser la compañía líder en Perú y Latinoamérica en brindar soluciones para la formación y capacitación de personal de la industria minera y futuros mineros en: seguridad, mantenimiento y operación de equipo, con el uso de tecnología de vanguardia y altos estándares de calidad para generar un impacto positivo en la sociedad.",
    photo: "/assets/cerv/about/VISION-3.png",
    dona: "Información adicional sobre la visión.",
    textPosition: "right",
    overlayBackground: "linear-gradient(rgb(16 9 62) 3.92%, rgba(9, 18, 29, 0) 36.79%, rgb(24 11 55) 83.98%), url('/assets/images/backgroup/bg_pagetitle.png') center center no-repeat"
};

const mission = {
    title: "Misión",
    description: "Brindar soluciones para capacitación de personal de la industria minera, y futuros mineros en seguridad industrial, mantenimiento y operación de equipo, con componentes tecnológicos de VR, AR, IA & Metaverso.",
    photo: "/assets/cerv/about/MISION-2.png",
    dona: "Información adicional sobre la misión.",
    textPosition: "left",
    overlayBackground: "rgb(14 3 39 / 50%)"
};

const valueProposition = {
    title: "Propuesta de Valor Única",
    description: "En CERV, diseñamos, desarrollamos y comercializamos soluciones para la capacitación y entrenamiento de personal de la industria minera, en las áreas de seguridad industrial, mantenimiento y operaciones, utilizando como valor agregado, tecnología alineada a la industria 4.0: VR, AR, AI & Metaverso, la integración de estas tecnologías nos permite entregar soluciones de capacitación para lograr asimilación de información por encima del 75% en las capacitaciones en minería, comparado con un nivel de asimilación de un 25% en soluciones tradicionales que prevalecen en la industria.",
    photo: "/assets/cerv/about/ARBOL-NAVIDAD-CERV.png",
    dona: "Información adicional sobre la propuesta de valor.",
    textPosition: "left",
    overlayBackground: "rgb(14 3 39 / 50%)"
};

const platform = {
    title: "Trabajo previo en Soluciones a Medida",
    description: [
        "Rubro: Minería, Transporte, Vehículos y Maquinaria Pesada, Industria, Seguridad Industrial, Operaciones, Mantenimiento Preventivo",
        "Soluciones en simuladores a medida y personalizados para empresas."
    ],
    photo: "https://www.youtube.com/watch?v=LFD83qrdmCI",
    type: "video",
    textPosition: "right",
    overlayBackground: "linear-gradient(rgb(16 9 62) 3.92%, rgba(9, 18, 29, 0) 36.79%, rgb(24 11 55) 83.98%), url('/assets/images/backgroup/bg_pagetitle.png') center center no-repeat"
};

const steps = [
    {
        id: 11,
        img: "/assets/cerv/about/01-EXPERIENCIA.png",
        title: "Experiencia",
        desc: "Los fundadores y el equipo de trabajo acumula más de 70 años en la industria minera.",
        number: "01",
        link: "#"
    },
    {
        id: 12,
        img: "/assets/cerv/about/02-INNOVACION.png",
        title: "Innovación",
        desc: "Hemos desarrollado una cultura de innovación que nos permite estar a la vanguardia.",
        number: "02",
        link: "#"
    },
    {
        id: 13,
        img: "/assets/cerv/about/03-LIDERAZGO.png",
        title: "Liderazgo",
        desc: "Hemos logrado liderar el mercado nacional de soluciones de XR con clientes mineros y participación en el ecosistema minero.",
        number: "03",
        link: "#"
    },
]

export { vision, mission, valueProposition, platform, steps };